import React from 'react';
import { Placeholder } from 'vendors/semantic-ui';

export const ProductFilterListLoader: React.FC = () => {
    return (
        <React.Fragment>
            <Placeholder>
                <Placeholder.Line length="long" />
                <Placeholder.Line length="medium" />
                <Placeholder.Line length="medium" />
                <Placeholder.Line length="medium" />
                <Placeholder.Line length="medium" />
                <Placeholder.Line length="long" />
                <Placeholder.Line length="medium" />
                <Placeholder.Line length="medium" />
                <Placeholder.Line length="medium" />
                <Placeholder.Line length="medium" />
                <Placeholder.Line length="long" />
                <Placeholder.Line length="medium" />
                <Placeholder.Line length="medium" />
                <Placeholder.Line length="medium" />
                <Placeholder.Line length="medium" />
            </Placeholder>
        </React.Fragment>
    );
};
